import { createSlice } from '@reduxjs/toolkit';
import { escapeHTML } from 'src/utils/escapeHTML';
import { setAuthorizationData } from 'src/utils/localStorage';

// 用户默认头像
const DEFAULT_USER_AVATAR = 'https://ui-cos.tate-a-tate.com/newChat/userAvatar.png';
// 智能体默认头像
const DEFAULT_BOT_AVATAR = 'https://ui-cos.tate-a-tate.com/newChat/robot_default_img.png';

const channelConfigSlice = createSlice({
  name: 'channelConfig',
  initialState: {
    config: {
      isSidebar: 0, // 是否显示侧边栏 0 不显示 1 显示
      topBar: '', // 顶部标题
      isAnonymous: 1, // 是否匿名 0 不匿名 1 匿名
      isTrial: 0, // 是否试用 0 不试用 1 试用
      accessPermission: 3, // 1 仅注册，2 注册后申请 3 匿名
      userAvatar: DEFAULT_USER_AVATAR, // 用户头像
      botAvatar: DEFAULT_BOT_AVATAR // 智能体头像
    }
  },
  reducers: {
    setChannelConfig (state, { payload }) {
      const data = {
        ...payload,
        topBar: escapeHTML(payload?.topBar || ''),
        userAvatar: payload?.userAvatar || DEFAULT_USER_AVATAR,
        botAvatar: payload?.botAvatar || DEFAULT_BOT_AVATAR
      };
      const searchParams = new URLSearchParams(window.location.search);
      const accessMode = searchParams.get('access_mode') ? searchParams.get('access_mode') : 'normal';
      // User access rights - 用户访问权限
      if (data?.isAnonymous === 1) {
        data.accessPermission = 3;
        if (accessMode === 'normal') {
          setAuthorizationData({ isAnonymous: '1' }); // 设置匿名状态 - 匿名
        }
      }
      if (data?.isAnonymous === 0 && data?.isTrial === 1) {
        data.accessPermission = 2;
        if (accessMode === 'normal') {
          setAuthorizationData({ isAnonymous: '0' }); // 设置匿名状态 - 非匿名
        }
      }
      if (data?.isAnonymous === 0 && data?.isTrial === 0) {
        data.accessPermission = 1;
        if (accessMode === 'normal') {
          setAuthorizationData({ isAnonymous: '0' }); // 设置匿名状态 - 非匿名
        }
      }
      state.config = data;
    }
  }
});

export const { setChannelConfig } = channelConfigSlice.actions;
export default channelConfigSlice.reducer;
